__turbopack_context__.v({
  "teasers": "_9TYKOW_teasers",
});
